import React, { ReactNode } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { EASE } from "../utils/motion";
type RevealProps = {
  children: ReactNode;
  delay?: number;
  y?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  y = 28,
  className = ""
}: RevealProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={{
    opacity: 0,
    y: reduce ? 0 : y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: reduce ? 0.01 : 0.75,
    delay: reduce ? 0 : delay,
    ease: EASE
  }} data-id="element-351" data-mp="3gitjshk62573">
      {children}
    </motion.div>;
}